<!--Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.-->
<footer class="footer bg-footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-column">
        <div class="footer-logo">
          <img src="../../../assets/images/sadiant-logo.png"
               alt="Sadiant Health"
               width="200"
               height="40">
        </div>
        <p class="footer-description">
          For all clinicians. One dedicated person from your first call, to first shift and beyond.
        </p>
        <div class="social-links">
          <a href="https://www.facebook.com/sadiant"
             target="_blank"
             rel="noopener noreferrer"
             aria-label="Facebook"><i class="pi pi-facebook"></i></a>
          <a href="https://twitter.com/Sadiant_Health"
             target="_blank"
             rel="noopener noreferrer"
             aria-label="Twitter"><i class="pi pi-twitter"></i></a>
          <a href="https://www.instagram.com/sadianthealth"
             target="_blank"
             rel="noopener noreferrer"
             aria-label="Instagram"><i class="pi pi-instagram"></i></a>
          <a href="https://www.linkedin.com/company/sadiant-health"
             target="_blank"
             rel="noopener noreferrer"
             aria-label="LinkedIn"><i class="pi pi-linkedin"></i></a>
        </div>
      </div>

      <div class="footer-column">
        <h4>Company</h4>
        <ul>
          <li><a routerLink="/about-us">Our Mission</a></li>
          <li><a routerLink="/about-us">Our Team</a></li>
          <!-- <li><a routerLink="/news">News</a></li> -->
          <li><a href="https://careers.sadianthealth.com"
               target="_blank"
               rel="noopener noreferrer">Careers</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Services</h4>
        <ul>
          <li><a routerLink="/facilities">For Facilities</a></li>
          <li><a routerLink="/clinicians">For Clinicians</a></li>
          <!-- <li><a href="#">Staffing Solutions</a></li>
          <li><a href="#">Mobile App</a></li> -->
        </ul>
      </div>

      <div class="footer-column">
        <h4>Contact</h4>
        <ul>
          <li><a href="tel:+18175627256">817-562-7256</a></li>
          <li><a href="mailto:hello@sadianthealth.com">hello@sadianthealth.com</a></li>
          <li>2833 Crockett Street<br> Suite 112<br>Fort Worth, TX 76107</li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>2016 - {{year}} Sadiant Health LLC. All rights reserved.</p>
      <div class="footer-status">
        <span class="status-indicator"></span>
        <span>System Operational</span>
      </div>
      <div class="footer-bottom-links">
        <a [routerLink]="'/privacy-policy'">Privacy Policy</a>
        <a [routerLink]="'/terms-of-service'">Terms of Service</a>
      </div>
    </div>
  </div>
